<template lang="pug">
  input-image(
    v-model="image"
    :image-height="imageHeight"
    label="Image"
    fill-width)
</template>

<script>
import { reactive, toRefs, computed } from '@vue/composition-api'
import { injectRouteState } from '@iez/core'
import syncWithState from '@iez/lib/sync-with-state/'
import InputImage from '@iez/components/inputs/image/'

export default {
  components: {
    InputImage
  },

  setup () {
    const routeState = injectRouteState()

    const state = reactive({
      image: syncWithState({ state: routeState.dataState.data, prop: 'image' }),
      imageHeight: 200,
      imagePlaceholderStyle: computed(() => ({
        width: '100%',
        height: '100%',
        border: `1px dashed rgba(0, 0, 0, 0.54)`,
        borderRadius: `12px`
      }))
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>
